import getGiInfo from "./getGiInfo";

export const fetchGiData = async (): Promise<{
  versions: any;
  total_unique_orders_stored: number;
}> => {
  try {
    const giInfo = await getGiInfo();
    return giInfo;
  } catch (error) {
    console.error("Error fetching GI data:", error);
    throw error;
  }
};
